module.exports = __webpack_public_path__ + "static/img/3-6.11.5.a25b4b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/3-6.11.5.png
// module id = 1lhh
// module chunks = 0